<template>
  <div class="question-input">
    <input v-model="textContent" :disabled="disabled" class="question-input__input" />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    parameters: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      answerValue: '',
    };
  },

  computed: {
    textContent: {
      get() {
        return this.parameters ? this.parameters.currentAnswer : this.answerValue;
      },
      set(newAnswerValue) {
        this.answerValue = newAnswerValue;
        this.emmitFormattedAnswer();
      },
    },
  },

  methods: {
    emmitFormattedAnswer() {
      const formattedAnswer = {
        question_id: this.id,
        value: {
          content: this.answerValue,
        },
      };
      this.$emit('input', formattedAnswer);
    },
  },
};
</script>

<style lang="scss" scoped>
.question-input {
  margin-bottom: 16px;

  &__input {
    height: 50px;
    width: 100%;
    background: #FCFCFC;
    border: 1px solid #E2E6EA;
    border-radius: 4px;
    padding: 16px;
    font-size: 12px;

    &:focus {
      outline: unset;
      border-color: $color--primary;
    }
  }
}
</style>
